/**
 * QQMini 客户端品类与客户端通信
 */
import ua from '@tencent/docs-user-agent';
import i18n from '@i18next/i18n';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { IQQMiniBridgeManager, OperationScene, SaveToFileCenterParams, ExFileType, ExFileSource } from '../interfaces/qqmini-bridge-manager.interface';

const getSubstringAfterLastDot = (str) => {
    const regex = /.*\.(.*)/;
    const match = str.match(regex);
    return match ? match[1] : '';
};

export class QQMiniBridgeManager implements IQQMiniBridgeManager {
    private static instance: QQMiniBridgeManager;

    public static getInstance(): QQMiniBridgeManager {
        if (!QQMiniBridgeManager.instance) {
            QQMiniBridgeManager.instance = new QQMiniBridgeManager(window.mqq, (window as any).qqexBridge);
        }
        return QQMiniBridgeManager.instance;
    }

    private isReady: boolean;

    public constructor(private mqq: any, private qqexBridge: any) {
        this.isReady = !!(ua.isQQDesktopDocsClient && mqq && qqexBridge);
    }

    public saveToFileCenter = async (scene: OperationScene) => {
        if (!this.isReady) {
            return;
        }
        try {
            const params = await this.getSaveToFileParams(scene);
            const res = await this.qqexBridge.saveToFileCenter(params);
            window.log?.info(`[QQMiniBridgeManager] code: ${res.code}, data: ${res.data}, message: ${res.errMsg}`);
        } catch (error) {
            window.log?.error(`[QQMiniBridgeManager] catch error: ${error.message}`);
        }
    };

    private async getSaveToFileParams(scene: OperationScene): Promise<SaveToFileCenterParams> {
        const saveParams: SaveToFileCenterParams = {
            hashId: await this.getHashId(),
            filePath: this.localFilePath,
            fileName: this.localFileTitle,
        };
        switch (scene) {
            case OperationScene.LOCAL_SAVE:
                saveParams.qqInfo = this.aioQQInfo;
                break;
            case OperationScene.LOCAL_SAVE_AS:
                saveParams.source = ExFileSource.kLocal;
                saveParams.fileType = ExFileType.kFile;
                saveParams.fileSize = await this.getLocalFileSize();
                break;
        }
        return saveParams;
    }

    private async getHashId(): Promise<string> {
        return new Promise((resolve) => {
            this.mqq.invoke('qqmini', 'getHashId', {}, (response) => {
                resolve(response.data);
            });
        });
    }

    private async getLocalFileSize(): Promise<number> {
        return new Promise((resolve) => {
            this.mqq.invoke('docx', 'getFileStats', {
                file: this.localFilePath,
            }, (response) => {
                resolve(response.size);
            });
        });
    }

    private get localFilePath() {
        return getQuerySearchParams('localFilePath');
    }

    private get localFileTitle() {
        const titleSuffix = getSubstringAfterLastDot(this.localFilePath) || 'pptx';
        const title = getQuerySearchParams('title') || window.clientVars.padTitle || i18n.t('空白幻灯片');
        return `${title}.${titleSuffix}`;
    }

    private get aioQQInfo() {
        return getQuerySearchParams('qqInfo');
    }
}
